import React from 'react'
import { TreeEditingContext } from './context'
import { SkillsView as SkillsViewV2 } from '../tree/utility/SkillsView'

export function SkillsView({
  nodeId,
  treeId,
}: {
  nodeId: string
  treeId: string
}) {
  const { idMaps, treesUpdated } = React.useContext(TreeEditingContext)
  const node = idMaps[treeId]?.[nodeId]?.node
  if (!node) return null

  return <SkillsViewV2 node={node} onUpdate={() => treesUpdated([treeId])} />
}
